import { shortId } from '../../db/ids.js';

const PREFIX = 'recall.custom.';

/** Custom sessions live in sessionStorage so a refresh resumes the same card list. */
export function saveCustomSession({ title, cardIds, reschedule, returnTo }) {
  const id = shortId();
  sessionStorage.setItem(PREFIX + id, JSON.stringify({ title, cardIds, reschedule, returnTo }));
  return id;
}

export function readCustomSession(id) {
  try {
    return JSON.parse(sessionStorage.getItem(PREFIX + id));
  } catch {
    return null;
  }
}
